import React from "react";
import { NotificationListPage } from "../../Components/dashboard";

const OrgNotificationList = () => {
  return <NotificationListPage role="creator" />;
};

export default OrgNotificationList;
